import React from "react";
// core components
import { Col, Row } from 'reactstrap';
import { FaFileUpload, FaFolderPlus, FaTrash, FaFileDownload } from 'react-icons/fa'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { FILE_UPLOAD } from 'constants/ActionTypes';


import commonStyle from "commonStyle";

import Button from "components/Button";

import { withoutAuth } from "HOC"

class Sidebar extends React.Component {
  onDelete = () => {
    this.props.onDelete && this.props.onDelete();
  }

  onDownload = () => {
    this.props.onDownload && this.props.onDownload();
  }

  getPrefix = () => this.props.location.search ? queryString.parse(this.props.location.search).prefix : '';

  renderSingleSidebar = () => (
    <div
      style={{
        paddingLeft: 20,
        paddingRight: 10,
        paddingTop: 13
      }}
    >
      <Row>
        <p
          style={{ height: 20, color: commonStyle.primaryColor, cursor: 'pointer'}}
          onClick={this.onDelete}
        >
          <FaTrash />
          <span style={{ paddingLeft: 7, fontWeight: 400 }}>Delete file</span>
        </p>
      </Row>

      <Row>
        <p
          style={{ height: 20, color: commonStyle.primaryColor, cursor: 'pointer'}}
          onClick={this.onDownload}
        >
          <FaFileDownload />
          <span style={{ paddingLeft: 7, fontWeight: 400 }}>Download file</span>
        </p>
      </Row>
    </div>
  );

  renderMulitpleSidebar = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 10,
          paddingTop: 13
        }}
      >
        <Row>
          <p
            style={{ height: 20, color: commonStyle.primaryColor, cursor: 'pointer'}}
            onClick={this.onDelete}
          >
            <FaTrash />
            <span style={{ paddingLeft: 7, fontWeight: 400 }}>Delete all</span>
          </p>
        </Row>
      </div>
    </div>
  );

  renderNoSelectionSidebar = () => (
    <div
      style={{
        flexDirection: 'column',
        display: 'block',
        paddingLeft: '15px',
        paddingTop: 25
      }}
    >
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 10,
          paddingTop: 13
        }}
      >
        
      </div>
    </div>
  );

  renderSidebar = ({ oneSelected, multipleSelected }) => {
    let component = null;

    if (oneSelected) {
      component = this.renderSingleSidebar();
    } else if (multipleSelected) {
      component = this.renderMulitpleSidebar();
    } else {
      component = this.renderNoSelectionSidebar();
    }

    return (
      <div>
        <div
          style={{
            flexDirection: 'column',
            display: 'block',
            paddingLeft: '15px',
            paddingTop: 25
          }}
        >
          <div
            style={{
              width: '100%'
            }}
          >
            <Button onClick={() => this.upload.click()}>
              Upload
            </Button>
            <input
              ref={upload => this.upload = upload }
              type={'file'}
              style={{ display: 'none' }}
              multiple
              onChange={(event)=> {
                const files = event.target.files;

                /**
                  This is important because the files returned are of
                  Filelist and it doesnt have all the prototyle methodes
                  of an array
                **/
                const finalFiles = [];
                for (let i = files.length - 1; i >= 0; i--) {
                  finalFiles.push(files[i])
                }

                event.target.value = null

                this.props.dispatch({
                  type: FILE_UPLOAD,
                  files: finalFiles,
                  prefix: this.getPrefix()
                });
              }}
            />
          </div>
          <hr style={{ width: '100%' }}/>
        </div>
        {component}
      </div>
    );
  }

  render() {
    return this.renderSidebar(this.props);
  }
}

export default connect()(Sidebar);
